import { memo } from 'react'

/**
 * PaginationControls - Reusable pagination controls
 * Provides consistent pagination UI with page numbers and navigation buttons
 */
const PaginationControls = memo(function PaginationControls({
  currentPage,
  totalPages,
  onPageChange,
  t
}) {
  if (totalPages <= 1) return null

  return (
    <div className="flex items-center justify-between px-2 py-1.5 bg-gray-50 border-t">
      <span className="text-xs text-gray-600">
        {t('admin.pagination.page')} {currentPage} {t('admin.pagination.of')} {totalPages}
      </span>
      <div className="flex gap-1">
        <button
          onClick={() => onPageChange(Math.max(1, currentPage - 1))}
          disabled={currentPage === 1}
          className="px-2 py-1 text-xs font-medium text-gray-700 bg-white rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {t('common.previous')}
        </button>
        <button
          onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage === totalPages}
          className="px-2 py-1 text-xs font-medium text-gray-700 bg-white rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {t('common.next')}
        </button>
      </div>
    </div>
  )
})

export default PaginationControls
